<span class="usa-tooltip width-full">
    <a
      *ngIf="buttonIsEnabled"
      (click)="generateZip()"
      (keydown.enter)="generateZip()"
      (keyup.space)="generateZip()"
      class="usa-button usa-button--accent-warm usa-tooltip__trigger"
      data-position="right"
      title=""
      aria-describedby="tooltip-307973"
      tabindex="0"
      role="button">
      {{ saveAsInfo.btnName }}
    </a>
    <span
      class="usa-tooltip__body"
      id="tooltip-307973"
      role="tooltip"
      aria-hidden="true">
      This allows you to download a zipped file with all ICT forms in json format.
    </span>
  </span>
